import { Environment, MGMAuth } from '@mgmresorts/mgm-auth-js-sdk';

import { AuthConfig } from '../config.types';
import { clientUrl } from '../utils/host';
import { actually } from '../utils/logging';
import { Mutex } from '../utils/Mutex';
import { selectValueByApiEnv } from '../utils/selectValueByApiEnv';

import { isWindowDefined } from '#next/isWindowDefined';

const defaultAuthConfig: AuthConfig = {
  environment: (process.env.API_ENV ?? 'DEV') as Environment,
  redirectUri: selectValueByApiEnv({
    DEV: `${clientUrl}/auth/login`,
    PREPROD: `${clientUrl}/auth/login`,
    PROD: `${clientUrl}/auth/login`,
    QA4: `${clientUrl}/auth/login`,
    UAT: `${clientUrl}/auth/login`,
  }),
};

export const getDynamicRedirectUri = () => {
  return encodeURIComponent(
    `${defaultAuthConfig.redirectUri}?next=${window ? encodeURIComponent(window?.location.href) : ''}`,
  );
};

export const buildAuthConfig = (overrides: Partial<AuthConfig> = {}): AuthConfig => {
  return { ...defaultAuthConfig, ...overrides };
};

const authMutex = new Mutex();

export const getAuthClientSync = () => window.__ROOM_BOOKING_AUTH_CLIENT;

export const getAuthClient = async (): Promise<MGMAuth> => {
  return await authMutex.acquire(() => {
    if (!isWindowDefined()) return new MGMAuth(buildAuthConfig());

    let client = window.__ROOM_BOOKING_AUTH_CLIENT;

    if (!client) {
      client = new MGMAuth(buildAuthConfig());

      /* 
        Only triggers when user signs out from another tab or another MGM application that uses AuthSDK
      */
      client.onSignOut = () => {
        actually.log('SIGN OUT DETECTED!');
        window.location.reload();
      };

      /* 
        Only triggers when user signs in from another tab or another MGM application that uses AuthSDK
      */
      client.onSignIn = () => {
        actually.log('SIGN IN DETECTED!');
        window.location.reload();
      };
    }

    window.__ROOM_BOOKING_AUTH_CLIENT = client;

    return window.__ROOM_BOOKING_AUTH_CLIENT;
  });
};
